import { Flex, Progress, theme } from 'antd';
import styled from 'styled-components';

import BaseText from '@components/typography/BaseText';

// Numbers line up from row to row
const Value = styled(BaseText)`
	&& {
		font-variant-numeric: tabular-nums;
		white-space: nowrap;
	}
`;

/**
 * A score as a thin bar in its colour, and the number.
 *
 * @param {number} value - 0–1
 * @param {string} color - The bar's colour
 */
const Score = ({ value, color }) => {
	const { token } = theme.useToken();

	return (
		<Flex align="center" gap="small" style={{ flex: 'none' }}>
			<Progress
				percent={Math.max(0, Math.min(1, value)) * 100}
				showInfo={false}
				strokeColor={color}
				size={[token.sizeXL, token.sizeXXS]}
				styles={{ root: { margin: 0 } }}
			/>
			<Value size="xs" type="secondary">
				{value.toFixed(2)}
			</Value>
		</Flex>
	);
};

export default Score;
